export default __webpack_public_path__ + "static/media/14550.conference-committee.photo.e04f3076.jpg";